module.exports = __webpack_public_path__ + "img/seychelles.39d7e26.webp";